import { getQaDataAttr } from '@bygghemmait/utilities';
import { Button } from 'components/Button';

interface SortButtonProps {
  onClick: () => void;
  text: string;
  className: string;
  textClassName: string;
  sortOrder: number;
}

export const SortButton = ({
  onClick,
  text,
  className,
  textClassName,
  sortOrder
}: SortButtonProps) => {
  return (
    <Button
      onClick={onClick}
      className={className}
      appearance="tertiary"
      {...getQaDataAttr(`sort-by-${sortOrder}`)}
    >
      <p className={textClassName}>{text}</p>
    </Button>
  );
};
